import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AbstractIdbaRequestModel } from '../../models/abstract-idba-request-model';
import { environment } from 'src/environments/environment';
import { AbstractIdbaService } from '../../utils/abstract-idba-service.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { ComponentType } from '@angular/cdk/portal';

@Injectable({
  providedIn: 'root'
})
export class ReportService extends AbstractIdbaService {
  private filter: any;
  private reportApi: string;
  private reportProcedure: string;
  public title:string;
  public matDialogConfig: MatDialogConfig;
  public listReport:boolean;
  public treeReport:boolean;
  public tableStyle: any;

  constructor(http: HttpClient) {
    super(http);
  }

  setFilter(filter: any) {
    this.filter = filter;
  }

  getFilter() {
    return this.filter;
  }

  setFilterDialog<T, D = any>(filterComponent: ComponentType<T>, matDialogConfig: MatDialogConfig<D>){
    this.matDialogConfig = matDialogConfig;
    this.filterComponent = filterComponent;
  }

  setReportApi(reportApi: string, reportProcedure: string = "pi-executar") {
    this.reportApi = reportApi;
    this.reportProcedure = reportProcedure;
  }

  executeReport() {
    const request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = this.reportApi;
    request.procedure = this.reportProcedure;
    request.parameters = this.filter;

    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }

  getReportInfo() {
    const request: AbstractIdbaRequestModel = new AbstractIdbaRequestModel();
    request.program = "utils/report/report.p";
    request.procedure = "pi-get-report-info";

    return this.httpClient.post<any>(environment.apiURLIntegrate, request, {
      observe: 'response',
    });
  }
}